import * as Yup from "yup";

export const termsAndConditionsValidationSchema = Yup.boolean()
  .oneOf([true], "You must accept the terms and conditions")
  .required("You must accept the terms and conditions");
